let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("llAoz")).then(() => parcelRequire('6Lz9k'));